/**
 * 迁移注册表
 */

import type { Migration } from './types';

const migrations: Migration[] = [];

/** 注册迁移 */
export function registerMigration(m: Migration): void {
  const existing = migrations.find(x => x.version === m.version);
  if (existing) {
    throw new Error(`Migration version ${m.version} already registered`);
  }
  migrations.push(m);
  migrations.sort((a, b) => a.version - b.version);
}

/** 获取所有迁移 */
export function getMigrations(): readonly Migration[] {
  return migrations;
}

/** 获取指定版本之后的迁移 */
export function getMigrationsAfter(version: number): Migration[] {
  return migrations.filter(m => m.version > version);
}

/** 获取最新版本号 */
export function getLatestVersion(): number {
  if (migrations.length === 0) return 0;
  return migrations[migrations.length - 1].version;
}

// ============= 导入迁移脚本 =============
// 新增迁移时在这里添加 import

// 注意：现有的 v1-v3 迁移已经内置在 Dexie 配置中
// 这里只需要注册 v4+ 的新迁移

import './v4_addCnTranslation';
